module.exports = __webpack_public_path__ + "img/dashbord-icon.c8be7930.svg";